import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
const faqs = [{
  q: '¿Cómo recibo el Armador de Élite después de comprar?',
  a: 'Inmediatamente después de confirmar el pago recibís un mail en tu casilla con el enlace de descarga de todos los PDFs. Acceso en menos de 5 minutos.'
}, {
  q: '¿Sirve para armadores con poca experiencia o solo para los avanzados?',
  a: 'El sistema está diseñado para todos los niveles. Cada tomo incluye variaciones para nivel 1, nivel 2 y nivel 3. Tanto si empezás desde cero como si ya tenés años de experiencia, el programa se adapta a donde estás hoy.'
}, {
  q: '¿Es editable? ¿Puedo modificarlo?',
  a: 'Los PDFs están optimizados para leer, imprimir y usar directamente. Algunas planillas incluyen campos para completar digitalmente. No están habilitados para edición general pero funcionan perfectamente tal como están.'
}, {
  q: '¿Los 6 bonos están en las dos ofertas?',
  a: 'Sí. Los 6 bonos estratégicos están incluidos en ambas opciones sin costo adicional.'
}, {
  q: '¿Sirve si entreno solo o solo para los que tienen equipo?',
  a: 'Funciona en ambos contextos. El sistema incluye drills individuales, ejercicios para hacer solo y también dinámicas para aplicar con compañeros de equipo.'
}, {
  q: '¿Qué diferencia tiene con otros materiales de voleibol?',
  a: 'Es el único sistema en español específicamente diseñado para la posición de armador que trabaja los 5 pilares juntos: técnica, táctica, físico, liderazgo y mentalidad. No es contenido genérico. Es un programa completo y progresivo para tu posición.'
}, {
  q: '¿Por qué elegir el Pack Élite y no el estándar?',
  a: 'Si querés solo el sistema de desarrollo del armador, el Estándar alcanza. Si además querés prepararte para competir al máximo nivel y construir tu marca como armador, el Pack Élite lo tiene todo.'
}, {
  q: '¿Tiene garantía real?',
  a: 'Sí. 7 días de garantía total. Si no es lo que esperabas, te devolvemos el 100% sin preguntas.'
}];
export const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 bg-navy-900" data-id="element-97">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-98">
        <FadeIn className="text-center mb-12" data-id="element-99">
          <h2 className="text-5xl font-bebas text-white" data-id="element-100">
            Preguntas Frecuentes
          </h2>
        </FadeIn>

        <div className="space-y-4" data-id="element-101">
          {faqs.map((faq, i) => <FadeIn key={i} delay={i * 0.05} data-id="element-102">
              <div className="bg-navy-950 border border-navy-800 rounded-xl overflow-hidden" data-id="element-103">
                <button className="w-full px-4 md:px-6 py-4 md:py-5 text-left flex justify-between items-center focus:outline-none" onClick={() => setOpenIndex(openIndex === i ? null : i)} data-id="element-104">
                  <span className="font-bold text-white text-sm md:text-base pr-4" data-id="element-105">
                    {faq.q}
                  </span>
                  <ChevronDown className={`w-5 h-5 text-gold-500 transition-transform duration-300 shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-106" />
                </button>
                <AnimatePresence data-id="element-107">
                  {openIndex === i && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-108">
                      <div className="px-4 md:px-6 pb-4 md:pb-5 text-sm md:text-base text-gray-400 leading-relaxed border-t border-navy-800/50 pt-3 md:pt-4" data-id="element-109">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
};